import { render, staticRenderFns } from "./passwordSuccess.vue?vue&type=template&id=24b85b75&scoped=true"
import script from "./passwordSuccess.vue?vue&type=script&lang=js"
export * from "./passwordSuccess.vue?vue&type=script&lang=js"
import style0 from "./passwordSuccess.vue?vue&type=style&index=0&id=24b85b75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b85b75",
  null
  
)

export default component.exports